import styled from 'styled-components'
import { colors } from '../utilities'

export const GetStartedWrapper = styled.div`
	width: 100%;
	background: white;
`;

export const HeaderSection = styled.div`
	padding: 8em 1em;
	max-width: 960px;
	margin: 2px auto;
	color: ${colors.almostWhite};
`;

export const BodySection = styled.div`
	max-width: 960px;
	margin: 0 auto;
	padding: 0em 1em 3em 1em;
`;
